require('./currencies-edit-container.scss')

module.exports = {
  template: require('./currencies-edit-container.pug')()
  controller: require('./currencies-edit-container.ctrl')
}
